module.exports = __webpack_public_path__ + "assets/img/station2.55350d3b.png";